var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container",style:(_vm.adjustPadding),on:{"click":_vm.focus,"focusout":_vm.focusout}},[_c(_vm.component,{tag:"component",attrs:{"get":_vm.get,"set":_vm.set}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }